export default function LoadingSpinner({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="h-10 w-10 border-4 border-maestro-500 border-t-transparent rounded-full animate-spin" />
      {label && <p className="mt-4 text-sm text-maestro-900/70">{label}</p>}
    </div>
  );
}
